import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1813a9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column bg-white border border-outline-color p-3 round-16" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "avatar rounded-circle" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = { class: "text-weight-500" }
const _hoisted_7 = { class: "d-flex align-items-center mt-1" }
const _hoisted_8 = { class: "text-gray-05 text-size-12 ml-1" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-blank" }, null, -1))
const _hoisted_11 = { class: "flex-grow-1" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "text-size-12 ml-2" }
const _hoisted_14 = { class: "d-flex bg-gray-01 p-2 mt-2 round-8" }
const _hoisted_15 = { class: "pr-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-05 text-size-10 pr-4" }, "勤務回数", -1))
const _hoisted_17 = { class: "text-gray-05 text-size-10 pr-2" }
const _hoisted_18 = { class: "text-size-16 text-weight-600 ml-1 mr-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-weight-600 pr-4" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-05 text-size-10" }, "累計給与額", -1))
const _hoisted_21 = { class: "text-weight-600" }
const _hoisted_22 = { class: "pr-3" }
const _hoisted_23 = { class: "pr-2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-05 text-size-10 text-nowrap" }, "\n                キャンセル率\n              ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-weight-600 pr-4" }, null, -1))
const _hoisted_26 = { class: "pr-3" }
const _hoisted_27 = { class: "pr-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-05 text-size-10 text-nowrap" }, "\n                直前キャンセル率\n              ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-weight-600 pr-4" }, null, -1))
const _hoisted_30 = { class: "bg-gray-01 p-2 mt-2 round-8" }
const _hoisted_31 = { class: "text-gray-05 text-size-10 pr-4" }
const _hoisted_32 = ["href"]
const _hoisted_33 = { class: "d-flex pr-2" }
const _hoisted_34 = { class: "text-gray-05 text-size-10 pr-2" }
const _hoisted_35 = { class: "text-size-16 text-weight-600 ml-1 mr-1" }
const _hoisted_36 = { class: "text-gray-05 text-size-10 pr-2" }
const _hoisted_37 = { class: "text-size-16 text-weight-600 ml-1 mr-1" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-danger text-size-10 pr-2" }, [
  /*#__PURE__*/_createTextVNode("\n              信用スコアが"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger text-size-16 text-weight-600 ml-1 mr-1" }, "0"),
  /*#__PURE__*/_createTextVNode("pt\n              のため、限定公開・指名オファー以外のお仕事には一時的に応募できません\n            ")
], -1))
const _hoisted_40 = { class: "text-danger text-size-10 pr-2" }
const _hoisted_41 = { class: "text-danger text-size-16 text-weight-600 mr-1" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-danger text-size-10 pr-2" }, "\n              当日・翌日のお仕事についてはこの件数に関係なく応募可能です\n            ", -1))
const _hoisted_44 = [
  _hoisted_43
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DefaultAvatar = _resolveComponent("DefaultAvatar")!
  const _component_RankIcon14 = _resolveComponent("RankIcon14")!
  const _component_FiveStars = _resolveComponent("FiveStars")!
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_CancelPercentage = _resolveComponent("CancelPercentage")!
  const _component_CancelPercentageSudden = _resolveComponent("CancelPercentageSudden")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.user.avatar)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.user.avatar,
              class: "avatar"
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createBlock(_component_DefaultAvatar, {
              key: 1,
              class: "avatar"
            }))
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.user.fullName), 1),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_RankIcon14, {
            rank: _ctx.user.rank
          }, null, 8, ["rank"]),
          _createTextVNode(),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.currentRankLabel), 1)
        ])
      ])
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createTextVNode(),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_RouterLink, {
          to: { name: 'MyReview' },
          class: "d-flex justify-content-between align-items-center bg-gray-01 p-2 mt-2 round-8"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_FiveStars, {
                "filled-star-image-src": _ctx.filledStarImageSrc,
                "filled-star-half-image-src": _ctx.filledStarHalfImageSrc,
                value: _ctx.truncatedAverageEvaluation
              }, null, 8, ["filled-star-image-src", "filled-star-half-image-src", "value"]),
              _createTextVNode(),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.truncatedAverageEvaluation) + "点 (" + _toDisplayString(_ctx.avgEvaluation.count || 0) + "件)\n            ", 1)
            ]),
            _createTextVNode(),
            _createVNode(_component_FeatherIcon, {
              icon: "chevron-right",
              size: "1x",
              class: "text-gray-05"
            })
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.user.workCount), 1),
              _createTextVNode("回\n            ")
            ]),
            _createTextVNode(),
            _hoisted_19
          ]),
          _createTextVNode(),
          _createElementVNode("div", null, [
            _hoisted_20,
            _createTextVNode(),
            _createElementVNode("p", _hoisted_21, "\n              ¥ " + _toDisplayString(_ctx.balance.totalIncome.toLocaleString()), 1)
          ])
        ]),
        _createTextVNode(),
        _createVNode(_component_RouterLink, {
          to: { name: 'CancelRate' },
          class: "d-flex align-items-center bg-gray-01 p-2 mt-2 round-8"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createTextVNode(),
                _createElementVNode("span", null, [
                  _createVNode(_component_CancelPercentage, {
                    percentage: _ctx.cancelPercentage,
                    numberClass: "text-size-16 text-weight-600 ml-1",
                    unitClass: "text-size-10"
                  }, null, 8, ["percentage"])
                ])
              ]),
              _createTextVNode(),
              _hoisted_25
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createTextVNode(),
                _createVNode(_component_CancelPercentageSudden, {
                  percentage: _ctx.suddenCancelPercentage,
                  numberClass: "text-size-16 text-weight-600 ml-1",
                  unitClass: "text-size-10"
                }, null, 8, ["percentage"])
              ]),
              _createTextVNode(),
              _hoisted_29
            ]),
            _createTextVNode(),
            _createVNode(_component_FeatherIcon, {
              icon: "chevron-right",
              size: "1x",
              class: "ml-auto text-gray-05"
            })
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("p", _hoisted_31, [
            _createElementVNode("a", {
              class: "link text-blue",
              href: _ctx.availableApplicationCountFaqUrl
            }, "応募可能な件数", 8, _hoisted_32)
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createTextVNode("\n              あと"),
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.myApplicationCount.available), 1),
              _createTextVNode("件\n            ")
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_36, [
              _createTextVNode("\n              （同時応募は最大"),
              _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.myApplicationCount.limit), 1),
              _createTextVNode("\n              件まで）\n            ")
            ])
          ]),
          _createTextVNode(),
          (_ctx.needDisplayCreditScoreRecoveryDate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _hoisted_39,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.displayCreditScoreRecoveryDate), 1),
                  _createTextVNode("に信用スコアが回復し、制限が解除されます\n            ")
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_44))
        ])
      ])
    ])
  ]))
}